






















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Moment from 'moment'

@Component

export default class ComponentProducaoPaciente extends Vue {
  @Prop(Boolean) isEdit
  @Prop(Object) producao

  date: any = ''
  formatedDate: any = ''
  showDatepicker: Boolean = false

  mounted() {
    if (!this.isEdit && this.date === '') {
      let date = new Date()
      date.toJSON()
      date.setHours(11)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)
      // @ts-ignore
      date = Moment(date).format('YYYY-MM-DD HH:mm:ss')

      this.date = date
    }
  }

  @Watch('producao', { deep: true })
  onProducaoDataRealizacaoChange() {
    if (this.isEdit && this.date === '') {
      this.date = this.producao.dataRealizacao
      this.formatedDate = Moment(this.date).format('DD/MM/YYYY')
    }
  }

  @Watch('date')
  onDateChange(newValue, oldValue) {
    this.producao.dataRealizacao = Moment(newValue).toDate()
    this.formatedDate = Moment(newValue).format('DD/MM/YYYY')
  }
}
